const operationFilters = {
  CompleteGameOrder: /Error creating payment method.; emsg:/,
};

export const isLogFiltered = ({ operation, graphQLErrors }) => {
  const { operationName } = operation || {};
  const { message } = graphQLErrors?.[0] || {};
  const filter = operationFilters[operationName];
  return filter ? filter.test(message) : false;
};
